import { render, staticRenderFns } from "./BarcodeReader.vue?vue&type=template&id=4249803a&scoped=true&"
import script from "./BarcodeReader.vue?vue&type=script&lang=js&"
export * from "./BarcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeReader.vue?vue&type=style&index=0&id=4249803a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249803a",
  null
  
)

export default component.exports